import UUID from 'uuid'
import { mergeObjs, deepCopy } from './miscUtil'
import MultiVectorLayer from './layers/vector/MultiVectorLayer'

export const LayerUtil = {
    /**
     * 创建矢量图层
     * @param {String} type Point|Polyline|Polygon
     * @param {Object} opt_options
     */
    createVectorLayer(type = 'point', opt_options) {
        // 基础结构
        let struct = {
                id: 'vector_' + UUID.v1(),
                source: {
                    type: 'geojson',
                    data: { type: 'FeatureCollection', features: [] }
                }
            },
            _type

        // 获取type
        switch (type.toUpperCase()) {
            case 'POINT':
                _type = 'circle'
                break
            case 'POLYLINE':
                _type = 'line'
                break
            case 'POLYGON':
                _type = 'fill'
                break
            default:
                _type = 'circle'
        }
        // 合并相关参数
        const layer = mergeObjs({}, struct, deepCopy(opt_options), {
            type: _type
        })

        // 返回图层
        return deepCopy(layer)
    },

    /**
     * 获取复合矢量图层快捷方法
     * @param {*} color
     * @param {*} map
     * @param {*} group
     * @param {*} opt_styles
     */
    getMVectorLayer(color, map, group, opt_styles) {
        // 图层组
        const layer = new MultiVectorLayer(group)
        layer.setMap(map)
        layer.Styles = mergeObjs(
            {
                point: {
                    'circle-radius': 6,
                    'circle-color': color
                },
                line: {
                    'line-color': color,
                    'line-opacity': 0.6,
                    'line-width': 2
                },
                // 属性驱动
                // {
                //     property: 'OID',
                //     stops: [[1, 'red'], [2, 'green'], [3, 'blue']]
                // }
                polygon: {
                    'fill-color': color,
                    'fill-opacity': 0.1
                }
            },
            opt_styles
        )

        return layer
    }
}
